import { render, staticRenderFns } from "./big-img-video.vue?vue&type=template&id=36cb33b4&scoped=true&"
import script from "./big-img-video.vue?vue&type=script&lang=js&"
export * from "./big-img-video.vue?vue&type=script&lang=js&"
import style0 from "./big-img-video.vue?vue&type=style&index=0&id=36cb33b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cb33b4",
  null
  
)

export default component.exports